import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home/home.component';
import { HeroComponent } from './hero/hero.component';
import { CapabilitiesComponent } from './capabilities/capabilities.component';
import { QualityDrivenComponent } from './quality-driven/quality-driven.component';
import { AiFeaturesComponent } from './ai-features/ai-features.component';
import { AdobeServicesComponent } from './adobe-services/adobe-services.component';
import { TestCaseValidationModalComponent } from './ai-features/test-case-validation-modal/test-case-validation-modal.component';
import { TestDataRecommendationModalComponent } from './ai-features/test-data-recommendation-modal/test-data-recommendation-modal.component';
import { IntelligentSummaryModalComponent } from './ai-features/intelligent-summary-modal/intelligent-summary-modal.component';
import { ImageComparisonModalComponent } from './ai-features/image-comparison-modal/image-comparison-modal.component';
import { PromptAutomationModalComponent } from './ai-features/prompt-automation-modal/prompt-automation-modal.component';


@NgModule({
  declarations: [HomeComponent, HeroComponent, CapabilitiesComponent, QualityDrivenComponent, AiFeaturesComponent, AdobeServicesComponent, IntelligentSummaryModalComponent, TestCaseValidationModalComponent, TestDataRecommendationModalComponent, ImageComparisonModalComponent, PromptAutomationModalComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    NgbModule
  ]
})

export class HomeModule { }
